import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import styles from '../../../../styles/DashboardV2.module.css';
import EmptyState from '../shared/EmptyState';

interface ListingPipelineWidgetProps {
    open: number;
    pending: number;
    closed: number;
    incomplete: number;
    sale: number;
    rental: number;
    loading?: boolean;
}

const ListingPipelineWidget: React.FC<ListingPipelineWidgetProps> = ({
    open, pending, closed, incomplete, sale, rental, loading,
}) => {
    const total = open + pending + closed + incomplete;

    return (
        <DashboardCard
            title="Listing Pipeline"
            loading={loading}
        >
            {total === 0 ? (
                <EmptyState icon="🏠" message="No listings yet." />
            ) : (
                <>
                    <div className={styles.pipeline}>
                        {[
                            { label: 'Open',       value: open,       color: '#10b981' },
                            { label: 'Pending',    value: pending,    color: '#f59e0b' },
                            { label: 'Closed',     value: closed,     color: '#6366f1' },
                            { label: 'Incomplete', value: incomplete, color: '#ef4444' },
                        ].map((step, i, arr) => (
                            <div key={step.label} className={styles.pipelineStep}
                                style={{ borderTop: `3px solid ${step.color}` }}>
                                <span className={styles.pipelineStepValue} style={{ color: step.color }}>
                                    {step.value}
                                </span>
                                <span className={styles.pipelineStepLabel}>{step.label}</span>
                                {i < arr.length - 1 && (
                                    <span className={styles.pipelineArrow}>›</span>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className={styles.pipelineTypeSplit}>
                        <div className={styles.pipelineTypeCard}>
                            <span className={styles.pipelineTypeLabel}>🏷 Sale</span>
                            <span className={styles.pipelineTypeValue}>{sale}</span>
                        </div>
                        <div className={styles.pipelineTypeCard}>
                            <span className={styles.pipelineTypeLabel}>🔑 Rental</span>
                            <span className={styles.pipelineTypeValue}>{rental}</span>
                        </div>
                    </div>
                </>
            )}
        </DashboardCard>
    );
};

export default ListingPipelineWidget;
